// extracted by mini-css-extract-plugin
export var closeButton = "_3t-3";
export var header = "_3t-0";
export var link = "_3t-1";
export var retryButton = "_3t-2";